import * as React from "react";

export interface Props {
    links: Array<any>;
    lang: string;
};

export default class ButtonsLinks extends React.Component<Props> {
    constructor(props: Props) {
        super(props);
    }
    render() {
        return (
            <div className="social-icons modern-social-links">
                {this.props.links.map((item, index) => {
                    return (
                        <a href={(typeof item.link == "string") ? item.link : item.link[this.props.lang]}
                           key={index}
                           className="social-link-item"
                           target="_blank"
                           rel="noopener noreferrer">
                            <i className={item.icon}></i>
                            <span className="link-label">{item.name}</span>
                        </a>
                    );
                })}
            </div>
        );
    }
}
